import React from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Mail, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-3 w-24 bg-muted animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="hover:text-primary hover:underline decoration-1 underline-offset-4 transition-all uppercase tracking-wide">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const businessName = "Christian Baks officielle platform";
  const address = "Danmark";
  return <section id="footer" className="dark bg-background text-foreground font-mono text-[12px] antialiased">
      <Separator className="bg-border h-[1px] w-full opacity-50" />
      
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/christian_bak_logo.png" alt={businessName} className="h-12 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <div className="max-w-xs text-muted-foreground leading-relaxed">
              <p>
                Christian Bak forener samfundsdebat med militær disciplin og kristen etik. Gennem fokus på Samfund & Moral, Disciplin & Karakterstyrke samt Tro & Eksistens, tages et nødvendigt opgør med hykleri. En platform for karakterdannelse og personligt ansvar i en tid, der kræver sandhed.
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-sm font-bold uppercase tracking-widest text-primary border-b border-border pb-2 w-fit">
              Navigation
            </h3>
            <MenuProvider menu_id="45" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-sm font-bold uppercase tracking-widest text-primary border-b border-border pb-2 w-fit">
              Kontakt & Info
            </h3>
            
            <div className="flex flex-col gap-3 text-muted-foreground">
              {address && <div className="flex items-center gap-3">
                  <MapPin className="size-4 shrink-0" />
                  <span>{address}</span>
                </div>}
              <div className="flex items-center gap-3">
                <Mail className="size-4 shrink-0" />
                <Link to="/ContactPage" className="hover:text-foreground transition-colors">
                  Kontakt os
                </Link>
              </div>
            </div>

            <div className="flex gap-4 mt-2">
              <Link to="#" aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" aria-label="Twitter" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" aria-label="LinkedIn" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="size-5" />
              </Link>
            </div>

            <div className="flex flex-col gap-2 mt-4">
              <Link to="#" className="hover:text-primary hover:underline decoration-1 underline-offset-4 transition-all">
                Privatlivspolitik
              </Link>
              <Link to="#" className="hover:text-primary hover:underline decoration-1 underline-offset-4 transition-all">
                Handelsbetingelser
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Separator className="bg-border h-[1px] w-full opacity-30" />
      
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground text-[10px] uppercase tracking-wider">
          <p className="text-center md:text-left">
            &copy; {currentYear} {businessName}. Alle rettigheder forbeholdes.
          </p>
          <p className="text-center md:text-right opacity-60">
            Design: Command & Conviction
          </p>
        </div>
      </div>
    </section>;
}